(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[15818,27602,98257],{

/***/ 3481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ fetchLeadBuyers; }
/* harmony export */ });
/* harmony import */ var _lib_shared_cookies__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76309);
/* harmony import */ var _services_http_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4806);


const fetchLeadBuyers = async (id, options = {})=>{
    const { maxRetries =40 , retryDelay =1000 , currentRetry =0  } = options;
    if (window.cancelledOperations && window.cancelledOperations.includes(id)) {
        return {
            data: null,
            error: new Error("Operation cancelled")
        };
    }
    const accessToken = (0,_lib_shared_cookies__WEBPACK_IMPORTED_MODULE_0__/* .getAccessToken */ .hP)();
    const config = {
        method: "post",
        url: `/api/operations`,
        data: {
            operationId: id
        },
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    };
    const { data: operationsResponse , error  } = await (0,_services_http_service__WEBPACK_IMPORTED_MODULE_1__/* .apiHandler */ .G)(()=>_services_http_service__WEBPACK_IMPORTED_MODULE_1__/* ["default"].client */ .Z.client(config));
    // If status is pending and we haven't exceeded max retries, retry
    if (operationsResponse?.data?.status === "PENDING" && currentRetry < maxRetries) {
        // Wait for the specified delay before retrying
        await new Promise((resolve)=>setTimeout(resolve, retryDelay));
        // Recursive call with incremented retry count
        return fetchLeadBuyers(id, {
            maxRetries,
            retryDelay,
            currentRetry: currentRetry + 1
        });
    }
    // Return the response or null
    return {
        data: {
            buyers: operationsResponse?.data?.buyers ?? [],
            status: operationsResponse?.data?.status ?? "FAILED",
            extraData: operationsResponse?.data?.extraData,
            showUnqualifiedOffers: operationsResponse?.data?.showUnqualifiedOffers
        },
        error
    };
};


/***/ }),

/***/ 25416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AffiliateOfferUrl; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/lib/shared/cookies.ts
var cookies = __webpack_require__(76309);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/api/index.ts + 19 modules
var api = __webpack_require__(21513);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
;// CONCATENATED MODULE: ./src/components/shared/affiliateOfferUrl/mobileIcon.tsx

const MobileIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        id: "Layer_2",
        viewBox: "0 0 16 22",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            id: "Layer_1-2",
            fill: "#fff",
            d: "M2 12.25V20 2zM2 22c-.55 0-1.02-.2-1.41-.59S0 20.55 0 20V2C0 1.45.2.98.59.59S1.45 0 2 0h10c.55 0 1.02.2 1.41.59S14 1.45 14 2v2h-2V2H2v18h10v-2h2v2c0 .55-.2 1.02-.59 1.41S12.55 22 12 22zm5.71-3.5c.19-.19.29-.43.29-.71s-.1-.52-.29-.71-.43-.29-.71-.29-.52.1-.71.29-.29.43-.29.71.1.52.29.71.43.29.71.29.52-.1.71-.29m3.62-4.65L9.88 12.4c.2-.18.35-.4.46-.64s.16-.5.16-.76-.05-.52-.16-.76-.26-.45-.46-.64l1.45-1.45c.38.38.68.82.88 1.31s.3 1 .3 1.54-.1 1.05-.3 1.54-.49.93-.88 1.31m2.45 2.45-1.4-1.4c.52-.52.92-1.11 1.2-1.78s.43-1.38.43-2.13-.14-1.46-.43-2.13-.68-1.26-1.2-1.78l1.4-1.4q1.08 1.05 1.65 2.43c.57 1.38.58 1.88.58 2.88s-.19 1.96-.58 2.88-.93 1.73-1.65 2.43"
        })
    });
/* harmony default export */ var mobileIcon = (MobileIcon);

// EXTERNAL MODULE: ./src/components/shared/affiliateOfferUrl/style.module.scss
var style_module = __webpack_require__(24027);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./src/components/shared/offerVertical/index.tsx
var offerVertical = __webpack_require__(71466);
;// CONCATENATED MODULE: ./src/components/shared/affiliateOfferUrl/index.tsx








function AffiliateOfferUrl({ className , children , customHref , offer , target , style , zone , template ="default"  }) {
    const { 0: listId , 1: setListId  } = (0,react.useState)(null);
    const { category , locale  } = (0,useDomainContext/* useDomainContext */.w)();
    const clickToCallLabel = (0,offerVertical/* getText */.Q)(category?.config?.clickToCallLabel, locale);
    (0,react.useEffect)(()=>{
        setListId((0,cookies/* getAffiliateListId */.Hf)());
    }, [
        cookies/* getAffiliateListId */.Hf
    ]);
    const queryParams = [];
    if (listId) {
        queryParams.push(`id=${listId}`);
    }
    if (offer?.category?.id) {
        queryParams.push(`categoryId=${offer.category.id.toString()}`);
    }
    if (zone) {
        queryParams.push(`zone=${zone}`);
    }
    let innerLinkContent = children;
    if (customHref) {
        if (template === "default") {
            innerLinkContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: children
            });
        } else {
            innerLinkContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (style_module_default()).clickToCallWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (style_module_default()).svgWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mobileIcon, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (style_module_default()).textWrapper,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (style_module_default()).clickToCall,
                                    children: clickToCallLabel || "Click to Call"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (style_module_default()).phoneNumberClick,
                                    children: children
                                })
                            ]
                        })
                    ]
                })
            });
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        style: style,
        target: target,
        className: className ?? "",
        rel: "noreferrer",
        href: customHref ?? `/offer/${offer?.slug ?? ""}?${queryParams.join("&")}`,
        onClick: ()=>{
            if (customHref) {
                void (0,api/* callEvent */.dr)({
                    event: "Call",
                    phoneNumber: customHref?.split("tel:")[1] ?? ""
                });
            }
        },
        children: innerLinkContent
    });
}


/***/ }),

/***/ 14203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24342);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2__);



const ButtonArrow = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["button-arrow"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().inner)
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ButtonArrow);


/***/ }),

/***/ 62070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ InsuranceOffer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_svg_checkIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76798);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _buttonArrow__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14203);
/* harmony import */ var _svg_starIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89894);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22727);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);






function InsuranceOffer({ item , index , state , category , primaryColor , textColor , btnLabel  }) {
    const { 0: clicked , 1: setClicked  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const handleClick = ()=>{
        setClicked(true);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["listing-block"])}`,
        children: [
            index === 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().order),
                style: {
                    backgroundColor: primaryColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg_starIcon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().logo),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: item.logoUrl,
                    alt: "logo"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().content),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "mb-4 font-bold lg:text-lg",
                        dangerouslySetInnerHTML: {
                            __html: item.title
                        },
                        style: {
                            color: textColor
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().features),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: "flex flex-col",
                            style: {
                                color: textColor
                            },
                            children: item.bulletedDescription?.map((feature, idx)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                    className: "text-sm font-light mb-2 flex items-start",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "children:h-3 children:w-3",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_svg_checkIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                                fill: primaryColor
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "ml-2",
                                            dangerouslySetInnerHTML: {
                                                __html: feature
                                            }
                                        })
                                    ]
                                }, idx))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().cta)} ${clicked ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().clicked) : ""}`,
                style: {
                    textAlign: "center"
                },
                children: [
                    item.revenue && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: "mb-1 block",
                        children: [
                            "$",
                            item.revenue
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        target: "_blank",
                        onClick: handleClick,
                        href: `/offer/${item.slug}&isExternalOffer=true`,
                        rel: "noreferrer",
                        style: {
                            backgroundColor: primaryColor
                        },
                        children: !clicked ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().main),
                            children: [
                                btnLabel ?? "view deal",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_buttonArrow__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().check),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_svg_checkIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
                        })
                    }),
                    index === 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["cta-state"]),
                        children: [
                            state,
                            " Best ",
                            category
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 19984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MortgageOffer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/lib/shared/types.ts
const periods = {
    PERIOD_FIXED_10YEARS: "10-Year Fixed ",
    PERIOD_FIXED_15YEARS: "15-Year Fixed ",
    PERIOD_FIXED_20YEARS: "20-Year Fixed ",
    PERIOD_FIXED_30YEARS: "30-Year Fixed (Default)",
    PERIOD_FIXED_40YEARS: "40-Year Fixed ",
    PERIOD_ARM_1YEARS: "1-Year ARM ",
    PERIOD_ARM_3YEARS: "3-Year ARM ",
    PERIOD_ARM_5YEARS: "5-Year ARM ",
    PERIOD_ARM_7YEARS: "7-Year ARM ",
    PERIOD_ARM_10YEARS: "10-Year ARM ",
    PERIOD_ARM_3YEARSIO: "3-Year ARM I/O",
    PERIOD_ARM_5YEARSIO: "5-Year ARM I/O",
    PERIOD_ARM_7YEARSIO: "7-Year ARM I/O"
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/shared/mortgageOffer/styles.module.scss
var styles_module = __webpack_require__(71098);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./src/lib/sharedUtils.ts
var sharedUtils = __webpack_require__(75094);
;// CONCATENATED MODULE: ./src/components/shared/mortgageOffer/index.tsx
// import CheckIcon from "@components/svg/checkIcon";





function MortgageOffer({ offer  }) {
    const { 0: popoverActive , 1: setPopoverActive  } = (0,react.useState)(false);
    function parseAmount(amount) {
        if (!amount) {
            return 0;
        }
        return parseInt(amount ? amount.replace(/[^0-9]/g, "") : "0");
    }
    const pointsAmount = parseAmount(offer.pointsAmount);
    const feesAmount = parseAmount(offer.feesAmount);
    const total = (0,sharedUtils/* parseToDollars */.Bv)(String(pointsAmount + feesAmount));
    const ref = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        if (popoverActive) {
            ref.current?.focus();
        }
    }, [
        popoverActive
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default())["lender-card"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default())["lender-metadata"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default())["lender-logo"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            target: "_blank",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: offer.logoUrl,
                                alt: offer.brandName
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default())["id-numbers"],
                        children: [
                            offer.nmls && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (styles_module_default())["nmls-id"],
                                children: [
                                    "NMLS #",
                                    offer.nmls
                                ]
                            }),
                            offer.license?.map((license)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (styles_module_default())["license-id"],
                                    children: [
                                        "License #",
                                        license
                                    ]
                                }, license);
                            })
                        ]
                    }),
                    offer.period && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default())["loan-type"],
                        children: periods[offer.period]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).apr,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default())["data-label"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "APR"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default())["data-value"],
                        children: offer.APR
                    }),
                    offer.period && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default())["loan-type"],
                        children: periods[offer.period]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).payment,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default())["data-label"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Payment"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default())["data-value"],
                        children: [
                            offer.monthlyPayment,
                            "\xa0",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                children: "/mo"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).rate,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default())["data-label"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Rate"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default())["data-value"],
                        children: offer.rate
                    })
                ]
            }),
            offer.period && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default())["loan-type"],
                children: periods[offer.period]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default())["fees-and-points"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default())["data-label"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Fees & Points"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default())["data-value"],
                        children: [
                            total,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default())["fee-breakdown-and-button"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    type: "button",
                                    className: (styles_module_default())["more-fee-info"],
                                    "aria-expanded": "false",
                                    onClick: ()=>{
                                        setPopoverActive((prev)=>!prev);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Info, {}),
                                        popoverActive && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            tabIndex: 0,
                                            className: (styles_module_default())["fee-breakdown"],
                                            ref: ref,
                                            onBlur: ()=>{
                                                setPopoverActive(false);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: (styles_module_default()).header,
                                                            children: "Fees & Points"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                            children: offer.points
                                                                        }),
                                                                        " Points *"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: (0,sharedUtils/* parseToDollars */.Bv)(String(pointsAmount))
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: "Lender Fees"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: (0,sharedUtils/* parseToDollars */.Bv)(String(feesAmount))
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: "Total Fees"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: total
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (styles_module_default())["about-points"],
                                                    children: "* Points are equal to 1% of the loan amount and lower the interest\xa0rate."
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default())["secondary-data-value"],
                        children: [
                            "Includes ",
                            offer.points,
                            "\xa0Points (",
                            (0,sharedUtils/* parseToDollars */.Bv)(String(pointsAmount)),
                            ")"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).cta,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    target: "_blank",
                    href: `/offer/${offer.slug}&isExternalOffer=true`,
                    className: (styles_module_default()).button,
                    rel: "noreferrer",
                    children: "Next"
                })
            })
        ]
    });
}
function Info() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: "9",
                    cy: "9",
                    r: "8",
                    fill: "none",
                    stroke: "#979797",
                    strokeWidth: "2",
                    className: "listing-more-fee-info-icon-stroke"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: "9",
                    cy: "5",
                    r: "1",
                    fill: "#979797",
                    className: "listing-more-fee-info-icon-fill"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                    x1: "9",
                    y1: "8",
                    x2: "9",
                    y2: "13",
                    fill: "none",
                    stroke: "#979797",
                    strokeLinecap: "round",
                    strokeWidth: "2",
                    className: "listing-more-fee-info-icon-stroke"
                })
            ]
        })
    });
}


/***/ }),

/***/ 27602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Banner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_shared_buttonArrow__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14203);
/* harmony import */ var _components_svg_checkIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76798);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);
/* harmony import */ var _affiliateOfferUrl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25416);
/* harmony import */ var _lib_shared_config__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(98218);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88737);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(44715);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_9__);










function Banner({ offer , className , displayLinkAndPhoneNumber , style , zone =_lib_shared_config__WEBPACK_IMPORTED_MODULE_7__/* .affiliateOfferZones.HOME_PAGE */ .ZR.HOME_PAGE , fullWidth =false  }) {
    const { isBot  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_8__/* .useDomainContext */ .w)();
    if (isBot) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
    const phoneNumber = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getPhoneNumber */ .ly)(offer);
    const borderStyle = {};
    switch(style?.borderStyle){
        case "all":
            borderStyle["border"] = "1px solid #e3e3e3";
            break;
        case "top":
            borderStyle["borderTop"] = "1px solid #e3e3e3";
            break;
        case "bottom":
            borderStyle["borderBottom"] = "1px solid #e3e3e3";
            break;
        case "none":
            borderStyle["border"] = "none";
            break;
        default:
            borderStyle["border"] = "1px solid #e3e3e3";
    }
    const buttonText = offer?.hiddenAttributes.buttonText ?? "Get Quote";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: `${fullWidth ? "max-w-7xl" : "max-w-6xl"} mx-auto mt-8 relative hover:shadow-xl transition-shadow ${className ?? ""}`,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-wrap flex-col lg:items-center lg:flex-row px-6 py-10",
            style: {
                backgroundColor: style?.background ?? "#F6F6F6",
                ...borderStyle,
                borderColor: style?.borderColor ?? "#e3e3e3"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: `w-1/2 lg:w-1/4 flex items-center justify-start lg:justify-center pr-5 relative ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_9___default().imgWrapper)}`,
                    children: offer?.logo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                        className: "w-full",
                        src: offer?.logo?.fullPath,
                        style: {
                            objectFit: "contain"
                        },
                        layout: "fill",
                        alt: "offer logo"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: `mt-5 lg:mt-0 lg:pr-8 lg:pl-6`,
                    style: {
                        flexGrow: 1,
                        flexShrink: 1,
                        flexBasis: 0
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "font-bold text-lg lg:text-xl",
                            children: offer?.description
                        }),
                        offer?.features && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: "mt-3",
                            children: offer?.features?.slice(0, 5)?.map((feature, idx)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                    style: {
                                        color: "#3EA636"
                                    },
                                    className: "flex items-center mb-2",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "children:w-3 children:h-3 mr-2 children:fill-current",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_svg_checkIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            style: {
                                                color: "#5B5B5B"
                                            },
                                            children: feature
                                        })
                                    ]
                                }, idx))
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col mt-3 lg:mt-0 ",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_affiliateOfferUrl__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            zone: zone,
                            target: !phoneNumber ? "_blank" : undefined,
                            className: `text-center py-3 rounded-lg lg:px-6 ${!displayLinkAndPhoneNumber ? `before:absolute before:w-full before:h-full before:left-0 before:top-0` : ""}`,
                            style: {
                                backgroundColor: style?.buttonBackground ?? "#3EA636",
                                color: style?.buttonForground ?? "white",
                                maxWidth: "300px",
                                minWidth: "200px"
                            },
                            offer: offer,
                            customHref: phoneNumber ? `tel:${phoneNumber ?? ""}` : undefined,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                children: [
                                    (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .formatPhoneNumber */ .un)(phoneNumber) ?? buttonText,
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_buttonArrow__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
                                ]
                            })
                        }),
                        displayLinkAndPhoneNumber && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_affiliateOfferUrl__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            zone: zone,
                            className: "text-left lg:text-center py-3 rounded-lg",
                            offer: offer,
                            target: "_blank",
                            style: {
                                color: "#0e5aa9"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: "View Deals"
                            })
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 71466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ getText; },
/* harmony export */   "Z": function() { return /* binding */ OfferVertical; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_variables_businessphonepricesVariables_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81331);
/* harmony import */ var _styles_variables_businessphonepricesVariables_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_variables_businessphonepricesVariables_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75094);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76877);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _affiliateOfferUrl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25416);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88737);







const getText = (text, locale)=>{
    return text?.[locale] ?? text?.["en"] ?? "";
};
function OfferVertical({ offer , zone , displayLinkAndPhoneNumber , customStyle , template ="default"  }) {
    const phoneNumber = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .getPhoneNumber */ .ly)(offer);
    const { domain , category , locale  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_4__/* .useDomainContext */ .w)();
    const callToActionTitle = getText(category?.config?.offerVerticalCallToActionTitle, locale);
    const callToActionSubTitle = getText(category?.config?.offerVerticalCallToActionSubTitle, locale);
    const buttonFallbackText = getText(category?.config?.offerVerticalButtonFallbackText, locale);
    const freeEvaluationNote = getText(category?.config?.offerVerticalFreeEvaluationNote, locale);
    const phoneNumberMessage = offer?.attributes.phoneNumberMessage ? offer?.attributes.phoneNumberMessage : offer?.hiddenAttributes.phoneNumberMessage ? offer?.hiddenAttributes.phoneNumberMessage : "";
    const outerSectionStyle = {
        "--buttonBackgroundColor": `${customStyle?.buttonBgColor ?? (_styles_variables_businessphonepricesVariables_module_scss__WEBPACK_IMPORTED_MODULE_5___default().autumnGlory)}`
    };
    const clickToCallBorder = typeof domain.config?.clickToCallBorder === "string" ? domain.config.clickToCallBorder : undefined;
    const clickToCallBtnBackground = typeof domain.config?.clickToCallBtnBackground === "string" ? domain.config.clickToCallBtnBackground : undefined;
    const clickToCallBtnForground = typeof domain.config?.clickToCallBtnForground === "string" ? domain.config.clickToCallBtnForground : undefined;
    const clickToCallBtnShadow = typeof domain.config?.clickToCallBtnShadow === "string" ? `rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, ${domain.config.clickToCallBtnShadow} 0px 10px 15px -3px, ${domain.config.clickToCallBtnShadow} 0px 4px 6px -4px ` : undefined;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().container)}  relative  mb-[30px] px-4 py-4   ${customStyle?.wrapperStyle ?? ""}`,
        style: outerSectionStyle,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-col flex-wrap items-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: `w-40 mb-4 flex justify-center ${customStyle?.fixedHeight ? "h-20" : ""}`,
                    style: {
                        borderColor: (_styles_variables_businessphonepricesVariables_module_scss__WEBPACK_IMPORTED_MODULE_5___default().offerBorderColor)
                    },
                    children: offer.logo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: offer.logo.fullPath,
                        alt: offer.title
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-full",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        style: {
                                            fontSize: "24px",
                                            fontWeight: "700",
                                            lineHeight: 1.2
                                        },
                                        dangerouslySetInnerHTML: {
                                            __html: phoneNumberMessage || callToActionTitle || "Call Now & Discuss Options!"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().secondTitle),
                                    children: callToActionSubTitle || "Review offers and coverage eligibility instantly."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "order-3 flex flex-col mt-2 w-auto",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_affiliateOfferUrl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    zone: zone,
                                    template: template,
                                    className: `${!displayLinkAndPhoneNumber ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().link) : ""} ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().linkPageBuilderStyle)} ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().btnStyle)} flex justify-center rounded-5 text-center px-[10px] py-[10px] text-[15px]`,
                                    offer: offer,
                                    customHref: phoneNumber ? `tel:${phoneNumber ?? ""}` : undefined,
                                    target: "_blank",
                                    style: {
                                        borderRadius: "12px",
                                        border: clickToCallBorder,
                                        background: clickToCallBtnBackground,
                                        color: clickToCallBtnForground,
                                        boxShadow: clickToCallBtnShadow
                                    },
                                    children: (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .formatPhoneNumber */ .un)(phoneNumber) || buttonFallbackText || "Let's Go"
                                }),
                                displayLinkAndPhoneNumber && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_affiliateOfferUrl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    zone: zone,
                                    className: `text-left lg:text-center py-3 rounded-lg ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().letGoStyle)}`,
                                    offer: offer,
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: buttonFallbackText || "Let's Go"
                                    })
                                })
                            ]
                        }),
                        (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .formatPhoneNumber */ .un)(phoneNumber) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            style: {
                                fontSize: "12px",
                                color: "#666",
                                textAlign: "center",
                                marginTop: "15px"
                            },
                            children: freeEvaluationNote || "Free Evaluation • No Obligation"
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 15818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* binding */ decodeFieldsFromText; },
  "Z": function() { return /* binding */ ThankYou; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
// EXTERNAL MODULE: ./src/components/shared/thankyou/style.module.scss
var style_module = __webpack_require__(52042);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/shared/insuranceOffer/index.tsx
var insuranceOffer = __webpack_require__(62070);
// EXTERNAL MODULE: ./src/lib/shared/config.ts
var config = __webpack_require__(98218);
// EXTERNAL MODULE: ./src/components/shared/offerVertical/index.tsx
var offerVertical = __webpack_require__(71466);
// EXTERNAL MODULE: ./src/lib/sharedUtils.ts
var sharedUtils = __webpack_require__(75094);
// EXTERNAL MODULE: ./src/components/shared/form/index.tsx
var shared_form = __webpack_require__(96119);
// EXTERNAL MODULE: ./src/components/shared/offerVertical/style.module.scss
var offerVertical_style_module = __webpack_require__(76877);
var offerVertical_style_module_default = /*#__PURE__*/__webpack_require__.n(offerVertical_style_module);
;// CONCATENATED MODULE: ./src/components/shared/offerVertical/skeleton.tsx



function VerticalOfferSkeleton() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: `${(offerVertical_style_module_default()).container}  relative  mb-[30px] px-4 py-4 border rounded-5`,
        style: {
            borderColor: "#e3e3e3"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col flex-wrap items-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col gap-2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "skeleton skeleton-text !w-[150px] !h-[80px] !mb-8"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "skeleton skeleton-text"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "skeleton skeleton-text"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex items-start gap-2 justify-between",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-col !w-[200px] !mt-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "skeleton skeleton-button"
                        })
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/shared/thankyou/widgets/index.tsx










function Widget({ type , winnerBuyer , loadingWinnerBuyer , onlyShowWinnerBuyer  }) {
    const { thankYouOffers , domain , visitDetails  } = (0,useDomainContext/* useDomainContext */.w)();
    const { query  } = (0,router.useRouter)();
    const { eb  } = query;
    const filteredOffers = (0,react.useMemo)(()=>thankYouOffers?.filter((offer)=>!(0,sharedUtils/* shouldRemoveBuyer */.fs)(eb, offer)), [
        thankYouOffers
    ]);
    const stickyOffer = (0,react.useMemo)(()=>{
        if (filteredOffers && filteredOffers.length) {
            const offer = filteredOffers?.find((offer)=>offer?.sticky);
            return offer;
        }
        return null;
    }, [
        thankYouOffers
    ]);
    const finalThankYouOffers = (0,react.useMemo)(()=>{
        if (onlyShowWinnerBuyer) {
            let filteredByBuyerId = domain.defaultOffers?.filter((offer)=>{
                return offer.buyer?.id === Number(winnerBuyer?.buyerId);
            });
            // If still more than 1 offer after buyer ID filter, filter by integrationUUID
            if (filteredByBuyerId && filteredByBuyerId.length > 1 && winnerBuyer?.integration?.uuid) {
                const filteredByIntegrationUUID = filteredByBuyerId.filter((offer)=>{
                    return offer.hiddenAttributes?.integrationUUID === winnerBuyer.integration.uuid;
                });
                // Only use integration UUID filtered results if we found matches
                if (filteredByIntegrationUUID.length > 0) {
                    filteredByBuyerId = filteredByIntegrationUUID;
                }
            }
            return filteredByBuyerId;
        }
        if (filteredOffers && filteredOffers.length && stickyOffer) {
            return filteredOffers.filter((offer)=>{
                return offer.id !== stickyOffer.id;
            });
        }
        return filteredOffers;
    }, [
        thankYouOffers,
        onlyShowWinnerBuyer,
        winnerBuyer?.buyerId,
        winnerBuyer?.integration?.uuid,
        domain.defaultOffers, 
    ]);
    switch(type){
        case "offers":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `flex flex-wrap gap-0 md:gap-5 mt-8 justify-center md:justify-start ${(style_module_default()).widgetWrapper}`,
                children: loadingWinnerBuyer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalOfferSkeleton, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        stickyOffer && !onlyShowWinnerBuyer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(offerVertical/* default */.Z, {
                            zone: config/* affiliateOfferZones.THANK_YOU */.ZR.THANK_YOU,
                            offer: stickyOffer,
                            displayLinkAndPhoneNumber: (0,sharedUtils/* doesOfferHaveALink */.hn)(stickyOffer)
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                        finalThankYouOffers?.map((offer, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(offerVertical/* default */.Z, {
                                zone: config/* affiliateOfferZones.THANK_YOU */.ZR.THANK_YOU,
                                offer: offer,
                                displayLinkAndPhoneNumber: (0,sharedUtils/* doesOfferHaveALink */.hn)(offer)
                            }, index))
                    ]
                })
            });
        case "form":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `${(style_module_default())["main-banner"]}`,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_form/* default */.Z, {
                    classes: {
                        formClassName: (style_module_default()).form,
                        stepTitleClassName: (style_module_default())["step-title"],
                        stepDescriptionClassName: (style_module_default())["step-description"],
                        formButtonClassName: (style_module_default())["form-button"],
                        formFieldClassName: (style_module_default())["form-field"],
                        formStepInnerClassName: (style_module_default())["steps-inner"],
                        stepClassName: (style_module_default()).step,
                        fieldsClassName: {
                            radio: (style_module_default())["radio-field"],
                            checkbox: (style_module_default())["checkbox-field"],
                            all: (style_module_default()).field,
                            select: (style_module_default())["select-field"],
                            date: (style_module_default())["date-filed"]
                        },
                        fieldsWrapperClassName: (style_module_default())["fields-wrapper"],
                        tcpaClassName: (style_module_default()).tcpa,
                        labelAsTitleClassName: (style_module_default())["label-as-step-title"],
                        fieldNoteClassName: (style_module_default())["field-note"],
                        fieldErrorMessageClassName: (style_module_default())["field-error-message"],
                        sellingPointClassName: (style_module_default())["selling-point"],
                        formFieldLabelClassName: (style_module_default())["form-field-label"]
                    },
                    colors: {
                        primaryColor: "black",
                        progressBar: "#4992e9"
                    },
                    showProgress: true,
                    goToThankYouPage: domain.config?.goToThankYouPage ?? false,
                    sellingPoint: domain.config?.sellingPoint ? (0,sharedUtils/* replacePlaceholders */.wT)(domain.config?.sellingPoint, {
                        region: visitDetails.region,
                        city: visitDetails?.city
                    }) : "",
                    sellingPointsSteps: domain.config?.sellingPointsSteps ?? "FIRST_STEP",
                    dynamicThankYouFields: domain.config?.dynamicThankYouFields ?? [
                        "firstName", 
                    ],
                    popupStyle: {
                        actionBtnBgColor: domain.config?.popupStyle?.actionBtnBgColor ?? "black",
                        actionBtnColor: domain.config?.popupStyle?.actionBtnColor ?? "#fff",
                        iconColor: domain.config?.popupStyle?.iconColor ?? "black"
                    }
                })
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
}

;// CONCATENATED MODULE: ./src/components/shared/thankyou/widgets/offersColumn.tsx









function OffersColumn({ winnerBuyer , loadingWinnerBuyer , onlyShowWinnerBuyer , showUnqualifiedOffers , template ="default"  }) {
    const { thankYouOffers , domain , category  } = (0,useDomainContext/* useDomainContext */.w)();
    const { query  } = (0,router.useRouter)();
    const { eb  } = query;
    const filteredOffers = (0,react.useMemo)(()=>thankYouOffers?.filter((offer)=>!(0,sharedUtils/* shouldRemoveBuyer */.fs)(eb, offer)), [
        thankYouOffers
    ]);
    const stickyOffer = (0,react.useMemo)(()=>{
        if (!winnerBuyer && category?.slug === "auto-accident") {
            const walkerAutoAccidentOffer = thankYouOffers?.find((offer)=>offer?.slug?.includes("walker")) ?? domain.defaultOffers?.find((offer)=>offer?.slug?.includes("walker"));
            if (walkerAutoAccidentOffer) {
                return walkerAutoAccidentOffer;
            }
        }
        if (filteredOffers && filteredOffers.length) {
            const offer = filteredOffers?.find((offer)=>offer?.sticky);
            return offer;
        }
        return null;
    }, [
        winnerBuyer,
        category?.slug,
        thankYouOffers,
        domain.defaultOffers,
        filteredOffers, 
    ]);
    const finalThankYouOffers = (0,react.useMemo)(()=>{
        if (showUnqualifiedOffers) {
            return domain.defaultOffers.filter((offer)=>offer.hiddenAttributes?.unqualifiedOffer === "True").slice(0, 1);
        }
        if (onlyShowWinnerBuyer) {
            let filteredByBuyerId = domain.defaultOffers?.filter((offer)=>{
                return offer.buyer?.id === Number(winnerBuyer?.buyerId);
            });
            // If still more than 1 offer after buyer ID filter, filter by integrationUUID
            if (filteredByBuyerId && filteredByBuyerId.length > 1 && winnerBuyer?.integration?.uuid) {
                const filteredByIntegrationUUID = filteredByBuyerId.filter((offer)=>{
                    return offer.hiddenAttributes?.integrationUUID === winnerBuyer.integration.uuid;
                });
                // Only use integration UUID filtered results if we found matches
                if (filteredByIntegrationUUID.length > 0) {
                    filteredByBuyerId = filteredByIntegrationUUID;
                }
            }
            return filteredByBuyerId;
        }
        if (filteredOffers && filteredOffers.length && stickyOffer) {
            return filteredOffers.filter((offer)=>{
                return offer.id !== stickyOffer.id;
            });
        }
        return filteredOffers;
    }, [
        thankYouOffers,
        onlyShowWinnerBuyer,
        winnerBuyer?.buyerId,
        winnerBuyer?.integration?.uuid,
        domain.defaultOffers,
        showUnqualifiedOffers, 
    ]);
    return finalThankYouOffers?.length || stickyOffer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full pt-10 md:w-2/4 lg:w-1/3 px-0 md:pl-12",
            children: loadingWinnerBuyer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalOfferSkeleton, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    stickyOffer && (!onlyShowWinnerBuyer || !winnerBuyer && category?.slug === "auto-accident" && stickyOffer?.slug?.includes("walker")) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(offerVertical/* default */.Z, {
                        zone: config/* affiliateOfferZones.THANK_YOU */.ZR.THANK_YOU,
                        template: template || "default",
                        offer: stickyOffer,
                        displayLinkAndPhoneNumber: (0,sharedUtils/* doesOfferHaveALink */.hn)(stickyOffer),
                        customStyle: {
                            wrapperStyle: (style_module_default()).offerColumnWrapper
                        }
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                    finalThankYouOffers?.map((offer, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(offerVertical/* default */.Z, {
                            zone: config/* affiliateOfferZones.THANK_YOU */.ZR.THANK_YOU,
                            offer: offer,
                            displayLinkAndPhoneNumber: (0,sharedUtils/* doesOfferHaveALink */.hn)(offer),
                            customStyle: {
                                wrapperStyle: (style_module_default()).offerColumnWrapper
                            }
                        }, offer?.id || index))
                ]
            })
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
}

// EXTERNAL MODULE: ./src/components/shared/offer/index.tsx
var shared_offer = __webpack_require__(27602);
;// CONCATENATED MODULE: ./src/lib/thankyouUtils.ts
const getWidgetType = (widgetTag)=>{
    const typeRegex = /type=(\w+)/;
    const typeMatch = widgetTag.match(typeRegex);
    if (typeMatch) {
        const widgetType = typeMatch[1];
        return widgetType;
    }
    return "notFound";
};
const extractWidgets = (body)=>{
    const widgetsArrayAfterSplitting = body.split(/\[widget type=[a-zA-Z0-9]+\]/i);
    const widgetRegex = /\[widget type=[a-zA-Z0-9]+\]/gi;
    const widgets = body.match(widgetRegex);
    return [
        widgets ? widgets : null,
        widgetsArrayAfterSplitting
    ];
};
const removeParagraphById = (htmlString, targetId)=>{
    if (!targetId) return htmlString; // If undefined, return original HTML
    // Convert targetId to an array if it's a single string
    const ids = Array.isArray(targetId) ? targetId : [
        targetId
    ];
    // Construct regex pattern to match any of the given IDs
    const regex = new RegExp(`<p[^>]*id=["'](${ids.join("|")})["'][^>]*>.*?</p>`, "gs");
    return htmlString.replace(regex, "");
};

// EXTERNAL MODULE: ./src/components/shared/mortgageOffer/index.tsx + 1 modules
var mortgageOffer = __webpack_require__(19984);
// EXTERNAL MODULE: ./src/hooks/useBingEnhancedConversion.tsx
var useBingEnhancedConversion = __webpack_require__(28185);
// EXTERNAL MODULE: ./src/api/buyers.ts
var buyers = __webpack_require__(3481);
;// CONCATENATED MODULE: ./src/components/shared/thankyou/winnerBuyerLoader.tsx




function WinnerBuyerLoader({ className =""  }) {
    const { category , routeConfig , locale  } = (0,useDomainContext/* useDomainContext */.w)();
    const sections = routeConfig?.templateConfig?.sections;
    const winnerBuyerLoadingIconColor = sections?.thankYou?.winnerBuyerLoadingIconColor;
    const winnerBuyerLoadingContainerBgColor = sections?.thankYou?.winnerBuyerLoadingContainerBgColor;
    const getWinnerBuyerLoadingTitle = ()=>{
        const winnerBuyerLoadingTitle = category?.config?.winnerBuyerLoadingTitle;
        return typeof winnerBuyerLoadingTitle === "object" && winnerBuyerLoadingTitle !== null ? winnerBuyerLoadingTitle?.[locale || "en"] ?? "Finding the Right Provider for You" : winnerBuyerLoadingTitle ?? "Finding the Right Provider for You";
    };
    const getWinnerBuyerLoadingDescription = ()=>{
        const winnerBuyerLoadingDescription = category?.config?.winnerBuyerLoadingDescription;
        return typeof winnerBuyerLoadingDescription === "object" && winnerBuyerLoadingDescription !== null ? winnerBuyerLoadingDescription?.[locale || "en"] ?? "Hang tight, we're matching you with a trusted service provider based on your request. This just takes a few moments." : winnerBuyerLoadingDescription ?? "Hang tight, we're matching you with a trusted service provider based on your request. This just takes a few moments.";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className || (style_module_default())["loading-container"],
        style: {
            background: winnerBuyerLoadingContainerBgColor || "#fff"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col justify-center items-center h-full max-w-3xl mx-auto text-center ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {
                    color: winnerBuyerLoadingIconColor
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-4xl font-semibold mb-10",
                    children: getWinnerBuyerLoadingTitle()
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-gray-600 mb-6 max-w-xl",
                    children: getWinnerBuyerLoadingDescription()
                })
            ]
        })
    });
}
function Loading({ color ="black"  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative mb-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: "86",
                height: "115",
                viewBox: "0 0 86 115",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M85.8078 88.5V9.80802C85.8078 7.1866 84.7869 4.72354 82.9355 2.87478C81.0842 1.02085 78.6212 0 76 0H24.6392C23.984 0 23.3556 0.260322 22.8922 0.723691L0.880491 22.7354C0.417346 23.1988 0.156799 23.8272 0.156799 24.4824V105.192C0.156799 110.6 4.55667 115 9.96482 115H76.0002C81.4081 115 85.808 110.6 85.808 105.192V86.8488H80.8666V105.192C80.8666 107.875 78.6834 110.059 76.0002 110.059H9.96482C7.28141 110.059 5.09843 107.875 5.09843 105.192V30.6217H20.9707C26.3788 30.6217 30.7787 26.2218 30.7787 20.8137V4.94141H76.0002C77.3002 4.94141 78.5217 5.44745 79.4417 6.3688C80.3605 7.28633 80.8666 8.50775 80.8666 9.80802V88.5H85.8078ZM25.8371 20.8137C25.8371 23.4971 23.6539 25.6803 20.9704 25.6803H5.09821V25.5057L25.6625 4.94141H25.8371V20.8137Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M39.3137 48.9648H20.9707C19.6062 48.9648 18.5 47.8586 18.5 46.4941C18.5 45.1296 19.6062 44.0234 20.9707 44.0234H39.3139C40.6784 44.0234 41.7846 45.1296 41.7846 46.4941C41.7846 47.8586 40.6782 48.9648 39.3137 48.9648Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M35.6451 63.6393H20.9707C19.6062 63.6393 18.5 62.5331 18.5 61.1685C18.5 59.804 19.6062 58.6978 20.9707 58.6978H35.6451C37.0096 58.6978 38.1158 59.804 38.1158 61.1685C38.1158 62.5331 37.0096 63.6393 35.6451 63.6393Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M35.6451 78.3139H20.9707C19.6062 78.3139 18.5 77.2077 18.5 75.8432C18.5 74.4787 19.6062 73.3725 20.9707 73.3725H35.6451C37.0096 73.3725 38.1158 74.4787 38.1158 75.8432C38.1158 77.2077 37.0096 78.3139 35.6451 78.3139Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M39.3137 92.9883H20.9707C19.6062 92.9883 18.5 91.8821 18.5 90.5176C18.5 89.1531 19.6062 88.0469 20.9707 88.0469H39.3139C40.6784 88.0469 41.7846 89.1531 41.7846 90.5176C41.7846 91.8821 40.6782 92.9883 39.3137 92.9883Z",
                        fill: color
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: "71",
                height: "71",
                viewBox: "0 0 71 71",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: (style_module_default()).magnifyingGlass,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M52.0902 48.4391L43.6251 39.9738C47.0735 35.7543 49.1453 30.3677 49.1453 24.5056C49.1453 11.0059 38.1626 0.0232239 24.6629 0.0232239C11.1632 0.0232239 0.180481 11.0059 0.180481 24.5056C0.180481 38.0053 11.1632 48.9881 24.6629 48.9881C30.5248 48.9881 35.9113 46.9163 40.1309 43.4678L48.5959 51.9331C49.0784 52.4156 49.7107 52.6568 50.3429 52.6568C50.975 52.6568 51.6077 52.4156 52.09 51.9331C53.0549 50.9684 53.0549 49.404 52.0902 48.4391ZM5.12166 24.5059C5.12166 13.7309 13.8877 4.96486 24.6627 4.96486C35.4376 4.96486 44.2037 13.7309 44.2037 24.5059C44.2037 35.2808 35.4376 44.0469 24.6627 44.0469C13.8879 44.0469 5.12166 35.2808 5.12166 24.5059Z",
                        fill: "#FF8B8B"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M63.1832 70.6862C61.1381 70.6862 59.2146 69.8891 57.7676 68.4419L48.5959 59.2704C47.1488 57.8231 46.3519 55.8997 46.3519 53.8547C46.3519 51.8098 47.1488 49.8863 48.5959 48.4391C50.0431 46.9917 51.9667 46.1946 54.0117 46.1946C56.0566 46.1946 57.9801 46.9917 59.4273 48.4389L68.5988 57.6103C70.0459 59.0575 70.843 60.9808 70.843 63.0259C70.843 65.071 70.0459 66.9943 68.5988 68.4417C67.1518 69.8893 65.2285 70.6862 63.1832 70.6862ZM54.0117 51.1362C53.2867 51.1362 52.6041 51.4192 52.09 51.9333C51.5761 52.4473 51.293 53.1296 51.293 53.8549C51.293 54.5801 51.5761 55.2627 52.09 55.7766L61.2617 64.9481C61.7756 65.4622 62.4579 65.745 63.1832 65.745C63.9085 65.745 64.5908 65.462 65.1047 64.9481C65.6186 64.434 65.9019 63.7516 65.9019 63.0264C65.9019 62.3011 65.6186 61.6187 65.1047 61.1048L55.9333 51.9333C55.4194 51.4192 54.737 51.1362 54.0117 51.1362Z",
                        fill: color
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/shared/thankyou/buyerCallNotice.tsx




function BuyerCallNotice({ winnerBuyer  }) {
    const { category , domain  } = (0,useDomainContext/* useDomainContext */.w)();
    const hasWinnerBuyerOffer = (0,react.useMemo)(()=>{
        return domain.defaultOffers?.find((offer)=>{
            return offer.buyer?.id === Number(winnerBuyer.buyerId);
        });
    }, []);
    const msg = (0,react.useMemo)(()=>{
        if (hasWinnerBuyerOffer) {
            return category?.config?.callNoticeDescription || "A representative from {name} will be with you shortly. Thanks for your patience. If you miss the call, you can reach out to your matched service provider using the number below.";
        }
        return category?.config?.callNoticeDescriptionNoOfferToDisplay || "A representative from {name} will be with you shortly. Thanks for your patience.";
    }, [
        hasWinnerBuyerOffer
    ]);
    if (winnerBuyer.buyerId) return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "p-5 lg:p-10 bg-[#f8f8f8] text-center my-8 lg:my-16 flex flex-col items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Phone, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "text-2xl lg:text-3xl font-semibold",
                dangerouslySetInnerHTML: {
                    __html: (category?.config?.callNoticeTitle || "Hold Tight, <span style='color: #5fa347'>Connecting</span> Your Call").replace("{name}", winnerBuyer?.displayName)
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-4 max-w-full lg:max-w-[80%] font-light",
                dangerouslySetInnerHTML: {
                    __html: msg?.replace("{name}", `<span style='color: #5fa347;font-weight: 600'>${winnerBuyer?.displayName}</span>`)
                }
            })
        ]
    });
}
const Phone = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            "clip-path": "url(#clip0_1493_272)",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M37.327 31.5246C37.1933 31.4932 37.0619 31.4433 36.9355 31.3741C36.182 30.9598 35.9067 30.0071 36.3205 29.2463C37.4915 27.0942 37.7597 24.6097 37.0758 22.2507C36.3885 19.8799 34.8248 17.9255 32.6729 16.7476C31.9186 16.3348 31.6415 15.3827 32.0542 14.621C32.4668 13.8592 33.4133 13.5767 34.1671 13.9895C37.0496 15.5672 39.144 18.185 40.0647 21.3605C40.982 24.524 40.6216 27.8573 39.0497 30.7466C38.705 31.3798 37.9913 31.6807 37.327 31.5246Z",
                    fill: "#5FA347",
                    className: (style_module_default()).bigWave
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M31.1108 28.1219C30.977 28.0905 30.8455 28.0406 30.7192 27.9714C29.9657 27.5571 29.6904 26.6044 30.1043 25.8436C30.3709 25.3535 30.4322 24.7888 30.277 24.2533C30.1205 23.7138 29.7635 23.2684 29.2715 22.9991C28.5172 22.5863 28.2401 21.6342 28.6528 20.8725C29.0654 20.1106 30.012 19.8278 30.7657 20.241C31.9883 20.9101 32.8762 22.019 33.266 23.3631C33.6545 24.7031 33.5008 26.1169 32.8334 27.3437C32.4886 27.977 31.7749 28.2779 31.1108 28.1219Z",
                    fill: "#5FA347",
                    className: (style_module_default()).smallWave
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    className: (style_module_default()).shake,
                    d: "M46.7813 41.2465L55.7325 43.3489C56.5691 43.5454 57.408 43.0206 57.6062 42.1769C57.8043 41.3332 57.2868 40.4898 56.4502 40.2934L47.499 38.191C44.4558 37.4762 41.3952 39.3853 40.6762 42.4466C39.9572 45.5078 41.8481 48.5798 44.8911 49.2946L49.8708 50.4641C51.2253 50.7823 52.0678 52.1464 51.7488 53.5048C51.4297 54.8633 50.068 55.7097 48.7135 55.3916L33.6263 51.848C34.8165 51.0399 35.7837 49.9314 36.4372 48.6021C37.4269 46.5896 37.5788 44.312 36.8651 42.1889L35.0438 36.7711C33.9934 33.6468 30.6075 31.9679 27.4954 33.0297L25.4525 33.7265L20.9085 20.2091L22.9423 19.5153C24.4529 18.9999 25.6744 17.924 26.3816 16.4858C27.0876 15.05 27.196 13.4253 26.687 11.9107L24.8657 6.49293C23.3925 2.11054 18.6431 -0.243271 14.2781 1.24583L9.98988 2.70888C7.87156 3.43151 6.15896 4.93982 5.1675 6.95618C4.17784 8.96856 4.0259 11.2463 4.73955 13.3694L16.7389 49.0651C17.6956 51.9111 20.0334 53.9013 22.7509 54.5394C24.218 54.8838 25.7962 54.8344 27.3264 54.3123L28.6792 53.8508C28.8005 53.9178 28.9328 53.9696 29.0742 54.0028L47.9959 58.4469C51.021 59.1574 54.0637 57.2596 54.7785 54.2163C55.4932 51.173 53.6136 48.119 50.5884 47.4085L45.6088 46.2389C44.2362 45.9165 43.3826 44.5346 43.7059 43.1581C44.0292 41.7816 45.4088 40.9241 46.7813 41.2465ZM26.3379 51.3411C23.5963 52.2763 20.6131 50.7995 19.6884 48.0485L7.68889 12.353C7.24227 11.0244 7.3372 9.59937 7.95618 8.34052C8.5769 7.07798 9.6503 6.13324 10.9784 5.68003L15.2665 4.21712C16.2287 3.88886 17.2201 3.85762 18.1423 4.07423C19.8483 4.47492 21.3161 5.724 21.9162 7.50965L23.7375 12.9274C23.9795 13.6472 23.9281 14.4195 23.5927 15.1016C23.2561 15.786 22.674 16.2984 21.9536 16.5442L18.4392 17.7432C18.047 17.877 17.723 18.1625 17.5391 18.5365C17.3552 18.9106 17.3263 19.3425 17.4589 19.737L23.0005 36.2224C23.2754 37.0402 24.1558 37.4773 24.9695 37.1996L28.484 36.0007C29.9731 35.493 31.5927 36.2943 32.0945 37.7876L33.9158 43.2054C34.3624 44.5339 34.2675 45.9588 33.6485 47.2178C33.0278 48.4803 31.9544 49.4251 30.6264 49.8781L26.3379 51.3411Z",
                    fill: "black"
                })
            ]
        })
    });

// EXTERNAL MODULE: ./src/lib/serverUtils.ts + 2 modules
var serverUtils = __webpack_require__(10456);
// EXTERNAL MODULE: ./src/components/shared/thankyou/widgets/angiWidget/style.module.scss
var angiWidget_style_module = __webpack_require__(77228);
var angiWidget_style_module_default = /*#__PURE__*/__webpack_require__.n(angiWidget_style_module);
// EXTERNAL MODULE: ./node_modules/react-content-loader/dist/react-content-loader.es.js
var react_content_loader_es = __webpack_require__(24561);
;// CONCATENATED MODULE: ./src/components/shared/thankyou/widgets/angiWidget/WidgetSkeleton.tsx



function WidgetSkeleton() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (angiWidget_style_module_default())["skeleton-container"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_content_loader_es/* default */.ZP, {
            speed: 2,
            width: "100%",
            height: "100%",
            viewBox: "0 0 400 600",
            backgroundColor: "#f3f3f3",
            foregroundColor: "#ecebeb",
            className: (angiWidget_style_module_default())["skeleton-loader"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "0",
                    y: "50",
                    rx: "4",
                    ry: "4",
                    width: "300",
                    height: "28"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "0",
                    y: "100",
                    rx: "4",
                    ry: "4",
                    width: "380",
                    height: "16"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "0",
                    y: "125",
                    rx: "4",
                    ry: "4",
                    width: "360",
                    height: "16"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "0",
                    y: "150",
                    rx: "4",
                    ry: "4",
                    width: "320",
                    height: "16"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "0",
                    y: "190",
                    rx: "4",
                    ry: "4",
                    width: "100",
                    height: "14"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "0",
                    y: "210",
                    rx: "6",
                    ry: "6",
                    width: "400",
                    height: "50"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "0",
                    y: "280",
                    rx: "4",
                    ry: "4",
                    width: "120",
                    height: "14"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "0",
                    y: "300",
                    rx: "6",
                    ry: "6",
                    width: "400",
                    height: "50"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "0",
                    y: "370",
                    rx: "4",
                    ry: "4",
                    width: "110",
                    height: "14"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "0",
                    y: "390",
                    rx: "6",
                    ry: "6",
                    width: "400",
                    height: "50"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "0",
                    y: "460",
                    rx: "6",
                    ry: "6",
                    width: "400",
                    height: "60"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "0",
                    y: "540",
                    rx: "4",
                    ry: "4",
                    width: "350",
                    height: "12"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "0",
                    y: "560",
                    rx: "4",
                    ry: "4",
                    width: "300",
                    height: "12"
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/shared/thankyou/widgets/angiWidget/angiWidget.tsx




function AngiWidget({ angiWidgetDetails , onStateChange  }) {
    const { 0: loading , 1: setLoading  } = (0,react.useState)(true);
    (0,react.useEffect)(()=>{
        if (!angiWidgetDetails.showWidget) {
            setLoading(false);
            onStateChange?.("thankYou");
            return;
        }
        const script = document.createElement("script");
        script.src = "https://request.angi.com/hcc/dropin-112a615a05e36545.js";
        const handleScriptLoad = ()=>{
            if (window?.initializeDropIn) {
                window.initializeDropIn(angiWidgetDetails.cjLeadKey);
            }
        };
        script.onload = handleScriptLoad;
        script.onerror = ()=>{
            setLoading(false);
            onStateChange?.("thankYou");
        };
        const handleMessage = (event)=>{
            const eventData = event.data;
            if (eventData?.event === "pageState") {
                if (eventData.payload === "WidgetLoaded") {
                    setLoading(false);
                    onStateChange?.("widgetLoaded");
                }
                if (eventData.payload === "ThankYou") {
                    onStateChange?.("thankYou");
                }
            }
        };
        window.addEventListener("message", handleMessage);
        document.body.appendChild(script);
        return ()=>{
            window.removeEventListener("message", handleMessage);
            if (document.body.contains(script)) {
                document.body.removeChild(script);
            }
        };
    }, [
        angiWidgetDetails.showWidget,
        angiWidgetDetails.cjLeadKey,
        onStateChange, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: `dropin-container ${(angiWidget_style_module_default())["dropin-container"]}`,
        children: loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSkeleton, {})
    });
}

// EXTERNAL MODULE: ./node_modules/react-dom/client.js
var client = __webpack_require__(20745);
// EXTERNAL MODULE: ./src/components/shared/thankyou/settlementCalculator.module.scss
var settlementCalculator_module = __webpack_require__(18670);
var settlementCalculator_module_default = /*#__PURE__*/__webpack_require__.n(settlementCalculator_module);
;// CONCATENATED MODULE: ./src/components/shared/thankyou/settlementCalculator.tsx
/* cspell:disable */ "use client";



const translations = {
    en: {
        title: "How Much Is Your Case Worth? Try Our Calculator",
        subtitle: "Get an instant, estimated range of your potential settlement. This is the fastest way to gauge the financial impact of your accident based on your unique situation.",
        medicalExpenses: "Medical Expenses ($)",
        medicalTooltip: "Total medical bills resulting from the accident.",
        propertyDamage: "Property Damage ($)",
        propertyTooltip: "Cost to repair or replace your vehicle or property.",
        lostIncome: "Lost Income ($)",
        lostIncomeTooltip: "Wages you've already lost due to missing work.",
        futureMedical: "Future Medical ($)",
        futureMedicalTooltip: "Estimated future surgeries, therapy, or medications.",
        futureLostIncome: "Estimated Future Lost Income ($)",
        futureLostIncomeTooltip: "If your injury affects your ability to work in the future, enter the estimated loss",
        painSuffering: "Pain & Suffering (1–5)",
        painMinimal: "1 - Minimal",
        painMild: "2 - Mild",
        painModerate: "3 - Moderate",
        painSevere: "4 - Severe",
        painExtreme: "5 - Extreme",
        estimatedTotal: "ESTIMATED SETTLEMENT TOTAL",
        disclaimer: "This is a rough estimate of what your case may be worth and is not a guaranteed settlement amount. Only a qualified attorney can evaluate the full value of your claim.",
        resetCalculator: "Reset Calculator"
    },
    es: {
        title: "\xbfCu\xe1nto valora su caso? Utilice nuestra calculadora",
        subtitle: "Obtenga al instante una estimaci\xf3n aproximada de la indemnizaci\xf3n que podr\xeda recibir. Es la forma m\xe1s r\xe1pida de evaluar las repercusiones econ\xf3micas de su accidente teniendo en cuenta su situaci\xf3n particular.",
        medicalExpenses: "Gastos m\xe9dicos ($)",
        medicalTooltip: "Total de facturas m\xe9dicas resultantes del accidente.",
        propertyDamage: "Da\xf1os materiales ($)",
        propertyTooltip: "Costo de reparar o reemplazar su veh\xedculo o propiedad.",
        lostIncome: "P\xe9rdida de ingresos ($)",
        lostIncomeTooltip: "Salarios que ya ha perdido por faltar al trabajo.",
        futureMedical: "Gastos m\xe9dicos futuros ($)",
        futureMedicalTooltip: "Cirug\xedas, terapias o medicamentos futuros estimados.",
        futureLostIncome: "Estimaci\xf3n de p\xe9rdidas de ingresos futuros ($)",
        futureLostIncomeTooltip: "Si su lesi\xf3n afecta su capacidad de trabajar en el futuro, ingrese la p\xe9rdida estimada",
        painSuffering: "Dolor y sufrimiento (1-5)",
        painMinimal: "1 - M\xednimo",
        painMild: "2 - Menor",
        painModerate: "3 - Moderada",
        painSevere: "4 - Grave",
        painExtreme: "5 - Extrema",
        estimatedTotal: "ESTIMACI\xd3N DEL TOTAL DEL ACUERDO",
        disclaimer: "Esta es una estimaci\xf3n aproximada del valor de su caso y no supone una cantidad garantizada del acuerdo. Solamente un abogado calificado puede evaluar la totalidad del valor de su reclamo.",
        resetCalculator: "Reiniciar Calculadora"
    }
};
function SettlementCalculator({ locale  }) {
    const text = translations[locale] || translations.en;
    const { 0: medical , 1: setMedical  } = (0,react.useState)(0);
    const { 0: property , 1: setProperty  } = (0,react.useState)(0);
    const { 0: lostIncome , 1: setLostIncome  } = (0,react.useState)(0);
    const { 0: futureMedical , 1: setFutureMedical  } = (0,react.useState)(0);
    const { 0: futureLostIncome , 1: setFutureLostIncome  } = (0,react.useState)(0);
    const { 0: pain , 1: setPain  } = (0,react.useState)(1);
    const total = (0,react.useMemo)(()=>{
        const subtotal = medical + property + lostIncome + futureMedical + futureLostIncome;
        return subtotal * pain;
    }, [
        medical,
        property,
        lostIncome,
        futureMedical,
        futureLostIncome,
        pain
    ]);
    const formatCurrency = (num)=>{
        if (num > 1000000) return "> $1,000,000";
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD"
        }).format(num);
    };
    const resetCalculator = ()=>{
        setMedical(0);
        setProperty(0);
        setLostIncome(0);
        setFutureMedical(0);
        setFutureLostIncome(0);
        setPain(1);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (settlementCalculator_module_default()).calcCard,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (settlementCalculator_module_default()).calcHeader,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: text.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: text.subtitle
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (settlementCalculator_module_default()).inputGrid,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputField, {
                        label: text.medicalExpenses,
                        tooltip: text.medicalTooltip,
                        value: medical,
                        onChange: setMedical
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputField, {
                        label: text.propertyDamage,
                        tooltip: text.propertyTooltip,
                        value: property,
                        onChange: setProperty
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputField, {
                        label: text.lostIncome,
                        tooltip: text.lostIncomeTooltip,
                        value: lostIncome,
                        onChange: setLostIncome
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputField, {
                        label: text.futureMedical,
                        tooltip: text.futureMedicalTooltip,
                        value: futureMedical,
                        onChange: setFutureMedical
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputField, {
                        label: text.futureLostIncome,
                        tooltip: text.futureLostIncomeTooltip,
                        value: futureLostIncome,
                        onChange: setFutureLostIncome
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (settlementCalculator_module_default()).fullWidth,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                children: text.painSuffering
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                value: pain,
                                onChange: (e)=>setPain(Number(e.target.value)),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: 1,
                                        children: text.painMinimal
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: 2,
                                        children: text.painMild
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: 3,
                                        children: text.painModerate
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: 4,
                                        children: text.painSevere
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: 5,
                                        children: text.painExtreme
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (settlementCalculator_module_default()).resultArea,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            color: "#fff",
                            fontWeight: 700,
                            fontSize: 12,
                            letterSpacing: 1
                        },
                        children: text.estimatedTotal
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (settlementCalculator_module_default()).totalVal,
                        children: formatCurrency(total)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (settlementCalculator_module_default()).disclaimer,
                        children: text.disclaimer
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: resetCalculator,
                        className: (settlementCalculator_module_default()).resetCalculator,
                        children: text.resetCalculator
                    })
                ]
            })
        ]
    });
}
function InputField({ label , tooltip , value , onChange  }) {
    const { 0: showTooltip , 1: setShowTooltip  } = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                children: [
                    label,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        onMouseEnter: ()=>setShowTooltip(true),
                        onMouseLeave: ()=>setShowTooltip(false),
                        style: {
                            marginLeft: 6,
                            cursor: "help",
                            position: "relative"
                        },
                        children: [
                            "ⓘ",
                            showTooltip && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                style: {
                                    position: "absolute",
                                    bottom: "140%",
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    width: 180,
                                    background: "#333",
                                    color: "#fff",
                                    padding: 8,
                                    borderRadius: 6,
                                    fontSize: 10,
                                    textAlign: "center",
                                    zIndex: 10
                                },
                                children: tooltip
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "number",
                value: value || "",
                onChange: (e)=>onChange(Number(e.target.value) || 0),
                placeholder: "0.00"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/shared/thankyou/index.tsx





















const decodeFieldsFromText = (text, fieldsState)=>{
    let clonedText = text;
    if (!fieldsState) return clonedText;
    const dynamicStrings = text?.match(/\${([^}]*)}/g);
    dynamicStrings?.forEach((item)=>{
        if (fieldsState[item.replace("${", "").replace("}", "")]) {
            const temp = clonedText.replace(item, fieldsState[item.replace("${", "").replace("}", "")]);
            clonedText = temp;
        }
    });
    return clonedText;
};
function ThankYou({ insuranceListingHeader , customThankYouMessage , hideListingTitle , inForm =false , isPageBuilder =false , className , form: formProp  }) {
    const { query  } = (0,router.useRouter)();
    const { eb , data  } = query;
    const urlData = data ? JSON.parse((0,sharedUtils/* base64DecodeUnicode */.e1)(data)) : null;
    const { form: contextForm , clicksOffers , visitDetails , thankYouOffers , thankyouListing , secondListing , domain , category , setAngiWidgetDetails , angiWidgetDetails , locale , routeConfig ,  } = (0,useDomainContext/* useDomainContext */.w)();
    const synchronizedForms = routeConfig?.templateConfig?.variantConfig?.synchronizedForms;
    // Prefer the form passed explicitly (e.g. a modal form when forms are
    // synchronized) over the domain-context form. When no prop is supplied
    // (standalone thank-you pages, non-synchronized flows) this falls back to
    // the context form, preserving the existing behavior exactly.
    const form = formProp && synchronizedForms ? formProp : contextForm;
    const { 0: successMessageArray , 1: setSuccessMessageArray  } = (0,react.useState)([]);
    const { 0: showCallNotice , 1: setShowCallNotice  } = (0,react.useState)(false);
    const { 0: hideThankyouContent , 1: setHideThankyouContent  } = (0,react.useState)(true);
    const { 0: loadingWinnerBuyer , 1: setLoadingWinnerBuyer  } = (0,react.useState)(false);
    const { 0: showUnqualifiedOffers , 1: setShowUnqualifiedOffers  } = (0,react.useState)(false);
    const onlyShowWinnerBuyer = true;
    const { 0: winnerBuyer , 1: setWinnerBuyer  } = (0,react.useState)(null);
    const { 0: widgets , 1: setWidgets  } = (0,react.useState)([]);
    const { 0: angiWidgetState , 1: setAngiWidgetState  } = (0,react.useState)("loading");
    const hasInitialized = (0,react.useRef)(false);
    const calculatorMounted = (0,react.useRef)(false);
    const renderList = (list)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: `w-full pt-6 mt-6`,
            style: {
                background: "#fbfbfb"
            },
            children: [
                list.pageTitle && !hideListingTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-xl md:text-2xl text-center md:text-left px-4 md:px-6 font-bold",
                    children: list.pageTitle
                }),
                list?.offers?.map((offer, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(shared_offer["default"], {
                        zone: config/* affiliateOfferZones.THANK_YOU */.ZR.THANK_YOU,
                        offer: offer,
                        className: `mt-0 ${(style_module_default()).offersList}`,
                        style: {
                            borderStyle: "bottom",
                            background: "transparent",
                            borderColor: "#eee",
                            buttonBackground: "#3EA636",
                            buttonForground: "#fff"
                        }
                    }, index))
            ]
        });
    (0,react.useEffect)(()=>{
        if (hasInitialized.current) return;
        hasInitialized.current = true;
        const skippedOperationId = sessionStorage.getItem(sharedUtils/* SKIPPED_OPERATION_ID_KEY */.UG);
        setHideThankyouContent(false);
        if (skippedOperationId) {
            setLoadingWinnerBuyer(true);
            const start = Date.now();
            (0,buyers/* fetchLeadBuyers */.c)(skippedOperationId).then((res)=>{
                if (res.data?.status === "SUCCESS" && res.data?.buyers?.length > 0) {
                    const angiWidgetConfig = res.data.buyers[0].integration?.response;
                    if (res.data.buyers[0].callOnThankYou) {
                        setShowCallNotice(true);
                    }
                    setWinnerBuyer(res.data.buyers[0]);
                    let widgetDetails;
                    if (angiWidgetConfig?.cjLeadKey === "" || angiWidgetConfig?.showWidget === false) {
                        widgetDetails = {
                            showWidget: false,
                            cjLeadKey: angiWidgetConfig.cjLeadKey ?? ""
                        };
                    } else {
                        widgetDetails = {
                            showWidget: angiWidgetConfig.showWidget,
                            cjLeadKey: angiWidgetConfig.cjLeadKey ?? ""
                        };
                    }
                    setAngiWidgetDetails(widgetDetails);
                    // If Angi widget will show, skip the winner buyer loader
                    // and go straight to Angi widget skeleton to avoid blank white screen
                    if (widgetDetails.showWidget) {
                        setLoadingWinnerBuyer(false);
                    }
                } else {
                    if (res.data?.showUnqualifiedOffers) {
                        setShowUnqualifiedOffers(true);
                    }
                    setAngiWidgetDetails({
                        showWidget: false,
                        cjLeadKey: ""
                    });
                }
            }).catch(()=>{
                setAngiWidgetDetails({
                    showWidget: false,
                    cjLeadKey: ""
                });
            }).finally(()=>{
                const elapsed = Date.now() - start;
                const minDuration = category?.config?.winnerBuyerLoadingMinDuration ?? 3000;
                if (elapsed < minDuration) {
                    setTimeout(()=>setLoadingWinnerBuyer(false), minDuration - elapsed);
                } else {
                    setLoadingWinnerBuyer(false);
                }
            });
        } else {
            setAngiWidgetDetails({
                showWidget: false,
                cjLeadKey: ""
            });
        }
        const customDomainThankYouMessage = domain?.textBlocks?.find((textBlock)=>textBlock.position === "custom-domain-thank-you")?.text;
        const fieldsData = JSON.parse(localStorage.getItem("dynamicFields"));
        const finalFormAnswers = fieldsData || urlData;
        (0,serverUtils/* handleFormAnswers */.KJ)(visitDetails);
        const [widgets, successMessageArrayAfterSplitting] = extractWidgets(customDomainThankYouMessage ? decodeFieldsFromText(customDomainThankYouMessage, finalFormAnswers) : form ? decodeFieldsFromText(form.successMessage, finalFormAnswers) : "");
        setWidgets(widgets ? widgets : null);
        setSuccessMessageArray(successMessageArrayAfterSplitting);
    }, []);
    // Mount SettlementCalculator when DOM content is ready
    const mountCalculator = (node)=>{
        if (!node || calculatorMounted.current) return;
        const anchor = node.querySelector("#settlement-calculator-anchor");
        if (anchor && !anchor.hasAttribute("data-root-mounted")) {
            calculatorMounted.current = true;
            const root = (0,client.createRoot)(anchor);
            root.render(/*#__PURE__*/ (0,jsx_runtime.jsx)(SettlementCalculator, {
                locale: locale
            }));
            anchor.setAttribute("data-root-mounted", "true");
        }
    };
    (0,useBingEnhancedConversion/* useBingEnhancedConversion */.O)();
    const isAngiWidgetActive = angiWidgetDetails?.showWidget === true;
    const showThankYouContent = !isAngiWidgetActive || angiWidgetState === "thankYou";
    if (form || customThankYouMessage) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: `${(style_module_default())["thank-you-page"]} pb-10 relative`,
                children: [
                    isAngiWidgetActive && !inForm && /*#__PURE__*/ (0,jsx_runtime.jsx)(AngiWidget, {
                        angiWidgetDetails: angiWidgetDetails,
                        onStateChange: setAngiWidgetState
                    }),
                    !hideThankyouContent && (showThankYouContent || inForm) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            showCallNotice && winnerBuyer && !loadingWinnerBuyer && /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyerCallNotice, {
                                winnerBuyer: winnerBuyer
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: customThankYouMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    id: "thank-you-page",
                                    className: className,
                                    children: customThankYouMessage
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: thankYouOffers && thankYouOffers.length && (!widgets || widgets.length === 0) && !inForm ? "flex justify-center items-start flex-col-reverse md:flex-row" : "",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            id: "thank-you-page",
                                            className: (thankYouOffers && thankYouOffers.length && (!widgets || widgets.length === 0) && !inForm ? "w-full md:w-2/4 lg:w-2/3" : "") + ` ${className ?? ""}`,
                                            children: loadingWinnerBuyer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(WinnerBuyerLoader, {
                                                className: "fixed inset-0 z-50 flex items-center justify-center bg-white"
                                            }) : successMessageArray.map((content, index)=>{
                                                const finalContent = removeParagraphById(content, eb);
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            ref: mountCalculator,
                                                            dangerouslySetInnerHTML: {
                                                                __html: finalContent
                                                            }
                                                        }),
                                                        widgets?.[index] ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Widget, {
                                                            type: getWidgetType(widgets[index]),
                                                            winnerBuyer: winnerBuyer ?? null,
                                                            loadingWinnerBuyer: loadingWinnerBuyer,
                                                            onlyShowWinnerBuyer: onlyShowWinnerBuyer
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                                    ]
                                                }, index);
                                            })
                                        }),
                                        !inForm && !loadingWinnerBuyer && (!widgets || widgets.length === 0) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OffersColumn, {
                                            winnerBuyer: winnerBuyer ?? null,
                                            loadingWinnerBuyer: loadingWinnerBuyer,
                                            onlyShowWinnerBuyer: onlyShowWinnerBuyer,
                                            showUnqualifiedOffers: showUnqualifiedOffers,
                                            template: "thankYou"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                    ]
                                })
                            })
                        ]
                    }),
                    !inForm && !isPageBuilder && insuranceListingHeader && clicksOffers && clicksOffers.length && !clicksOffers[0].isMortgage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "my-4 pt-10 font-bold text-center text-lg md:text-xl",
                        children: insuranceListingHeader
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                    clicksOffers && !inForm && !isPageBuilder && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-10 md:mt-5 w-full",
                        children: clicksOffers?.map((clickOffer, index)=>!clickOffer.isMortgage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(insuranceOffer/* default */.Z, {
                                index: index,
                                item: clickOffer,
                                category: "Auto Insurance",
                                state: visitDetails?.region,
                                primaryColor: "#f79626",
                                textColor: "#266199",
                                btnLabel: "I Want That"
                            }, index) : /*#__PURE__*/ (0,jsx_runtime.jsx)(mortgageOffer/* default */.Z, {
                                // index={index}
                                offer: clickOffer
                            }, index))
                    }),
                    secondListing && secondListing?.offers?.length && !inForm ? renderList(secondListing) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                    thankyouListing && thankyouListing?.offers?.length && !inForm ? renderList(thankyouListing) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
}


/***/ }),

/***/ 76798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CheckIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function CheckIcon({ className , fill  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        x: "0",
        y: "0",
        enableBackground: "new 0 0 32 26",
        version: "1.1",
        viewBox: "0 0 32 26",
        xmlSpace: "preserve",
        className: className ?? "",
        fill: fill,
        style: {
            fill: fill
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M27.1 0L25 2.2 10.7 17.4l-4.3-4.3L4.2 11 0 15.2l2.1 2.1 6.5 6.5 2.2 2.2 2.1-2.2L29.4 6.3l2.1-2.2L27.1 0z"
        })
    });
}


/***/ }),

/***/ 89894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ StarIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function StarIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "517",
        height: "493",
        fill: "none",
        viewBox: "0 0 517 493",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            d: "M257.542.014a11.2 11.2 0 00-10.105 7.719l-56.223 168.68H11.164a11.2 11.2 0 00-6.613 20.21l146.25 106.94-56.223 174.56v.004a11.197 11.197 0 004.086 12.535 11.203 11.203 0 0013.184-.039l146.25-106.94 146.25 106.94a11.203 11.203 0 0013.184.039 11.196 11.196 0 004.086-12.535l-56.223-174.56 146.25-106.94v-.004a11.2 11.2 0 00-6.613-20.21h-180.05L268.759 7.733a11.2 11.2 0 00-11.207-7.72h-.01z",
            clipRule: "evenodd"
        })
    });
}


/***/ }),

/***/ 28185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useBingEnhancedConversion; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useDomainContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88737);


const useBingEnhancedConversion = ()=>{
    const { visitDetails , domain  } = (0,_useDomainContext__WEBPACK_IMPORTED_MODULE_1__/* .useDomainContext */ .w)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (visitDetails.trafficSourceNetwork?.toLocaleLowerCase() === "bing" && domain.config?.useBingEnhancedConversion) {
            const sharedFieldsData = JSON.parse(localStorage.getItem("sharedFields"));
            // @ts-ignore
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            window.uetq = window.uetq || [];
            const formattedPhoneNumber = formatPhoneNumber(sharedFieldsData?.phoneNumber);
            const formattedEmail = formatEmail(sharedFieldsData?.email);
            if (formattedEmail || formattedPhoneNumber) {
                // @ts-ignore
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
                window.uetq.push("event", "MyAction", {
                    pid: {
                        em: formattedEmail,
                        ph: formattedPhoneNumber
                    }
                });
            }
        }
    }, []);
};
function formatEmail(email) {
    if (!email) {
        return "";
    }
    return email.trim().toLowerCase().replace(/\+.+@/, "@").replace(/\.+(?=@)/g, "").replace(/\s/g, "").replace(/^\.+|\.+$/g, "").normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
function formatPhoneNumber(phoneNumber) {
    if (!phoneNumber) {
        return "";
    }
    const cleanedPhoneNumber = phoneNumber.replace(/\D/g, "");
    const countryCode = !cleanedPhoneNumber.startsWith("1") ? "+1" : "+";
    const formattedPhoneNumber = countryCode + cleanedPhoneNumber;
    return formattedPhoneNumber;
}


/***/ }),

/***/ 24027:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"clickToCallWrapper":"style_clickToCallWrapper__VwAdQ","textWrapper":"style_textWrapper__4UGtd","svgWrapper":"style_svgWrapper__hIySB","clickToCall":"style_clickToCall__9Mqb6","phoneNumberClick":"style_phoneNumberClick__xFVNS"};

/***/ }),

/***/ 24342:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button-arrow":"styles_button-arrow__FF6j0","inner":"styles_inner__Ybwhd","expand":"styles_expand__Cx9pe"};

/***/ }),

/***/ 22727:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","listing-block":"styles_listing-block__RvN1M","order":"styles_order__Op_r2","logo":"styles_logo__uJaZK","content":"styles_content__iaJT3","features":"styles_features__U_7i_","cta":"styles_cta__yHY_B","check":"styles_check__nXx8q","cta-state":"styles_cta-state__ipINl","clicked":"styles_clicked__Sk_hn","listingModal":"styles_listingModal__7inDQ","categoryListingModal":"styles_categoryListingModal__e5ESi","blink":"styles_blink__6TbpR"};

/***/ }),

/***/ 71098:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"styles_button__050Y6","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","lender-card":"styles_lender-card__GNg6J","lender-metadata":"styles_lender-metadata__GqiuV","lender-logo":"styles_lender-logo__R9EUS","id-numbers":"styles_id-numbers__BPB93","nmls-id":"styles_nmls-id__IlrEl","loan-type":"styles_loan-type__GSLd9","apr":"styles_apr__JNkLs","data-value":"styles_data-value__XIoms","payment":"styles_payment__XFMxC","rate":"styles_rate__1CYok","fees-and-points":"styles_fees-and-points__Hvewy","data-label":"styles_data-label__j_GWp","fee-breakdown-and-button":"styles_fee-breakdown-and-button__6P_8W","secondary-data-value":"styles_secondary-data-value__F7URY","cta":"styles_cta__6sAYz","fee-breakdown":"styles_fee-breakdown__Jb_3_","header":"styles_header__3M_QF","about-points":"styles_about-points__7i_EZ","blink":"styles_blink__aatuJ"};

/***/ }),

/***/ 44715:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imgWrapper":"style_imgWrapper__UmsYV"};

/***/ }),

/***/ 76877:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__wOf18","title":"style_title__cWvij","linkPageBuilderStyle":"style_linkPageBuilderStyle__CqdI2","letGoStyle":"style_letGoStyle__5KJJo","link":"style_link__LGb3m","secondTitle":"style_secondTitle__6rLsc","btnStyle":"style_btnStyle__6X7g_"};

/***/ }),

/***/ 18670:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"calcCard":"settlementCalculator_calcCard__r1Qu2","calcHeader":"settlementCalculator_calcHeader__UR_fB","inputGrid":"settlementCalculator_inputGrid__IE6qq","resultArea":"settlementCalculator_resultArea__yXhnu","totalVal":"settlementCalculator_totalVal__KD62q","resetCalculator":"settlementCalculator_resetCalculator__1YjLQ","disclaimer":"settlementCalculator_disclaimer__l0FiV"};

/***/ }),

/***/ 52042:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"thank-you-page":"style_thank-you-page__63Qqv","offersList":"style_offersList__h9QyH","widgetWrapper":"style_widgetWrapper__Dhqop","selling-point":"style_selling-point__c8OX8","main-banner":"style_main-banner__G_nc6","form":"style_form__HjwJj","step":"style_step__P3O2C","form-field":"style_form-field__hexsH","step-title":"style_step-title__oYNmv","label-as-step-title":"style_label-as-step-title___7FVN","step-description":"style_step-description__KFhAd","form-button":"style_form-button__1_ZFY","form-field-label":"style_form-field-label__yhoi6","radio-field":"style_radio-field__PI_ii","checkbox-field":"style_checkbox-field__9WJAB","select-field":"style_select-field__5MU3L","date-filed":"style_date-filed__D1Ab2","field-note":"style_field-note__X4GD2","field-error-message":"style_field-error-message__A0bgw","styleForFirstLabelWithoutTitle":"style_styleForFirstLabelWithoutTitle__ZAKfw","loading-container":"style_loading-container__ADr_L","loading":"style_loading__9JLGX","magnifyingGlass":"style_magnifyingGlass__LPAIB","float":"style_float__t6l9V","bigWave":"style_bigWave__5c10v","fadeAndScale":"style_fadeAndScale__L4Q98","smallWave":"style_smallWave__nB6Bu","shake":"style_shake__Yj1jU","jump-shaking":"style_jump-shaking__simvK","offerColumnWrapper":"style_offerColumnWrapper__ImzHM"};

/***/ }),

/***/ 77228:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dropin-container":"style_dropin-container__EDLdY","skeleton-container":"style_skeleton-container__BrU1p","fadeIn":"style_fadeIn__1Q7P_","skeleton-loader":"style_skeleton-loader__lQGJN","shimmer":"style_shimmer__WAZth"};

/***/ }),

/***/ 81331:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"goGoGreen":"#008a7b","green":"#5bc1a4","bankVault":"#747474","autumnGlory":"#3ea636","offerBorderColor":"#e4e7eb"};

/***/ })

}]);